/* ------------------------------------------------------------------
   EmailLayout.js — sub-layout for Marketing → Email Marketing.
   Renders a left sub-sidebar (Lists / Campaigns / Automations / Settings)
   + the active sub-page. Mirrors SettingsLayout.
------------------------------------------------------------------ */
import React, { useEffect, useState } from 'react';
import { Offcanvas, Button } from 'react-bootstrap';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { List } from 'react-bootstrap-icons';

const NAV_ITEMS = [
  { to: 'lists',       label: 'Lists',       icon: 'fas fa-list-ul' },
  { to: 'campaigns',   label: 'Campaigns',   icon: 'fas fa-paper-plane' },
  { to: 'automations', label: 'Automations', icon: 'fas fa-diagram-project' },
  { to: 'settings',    label: 'Settings',    icon: 'fas fa-gear' },
];

const EmailLink = ({ to, label, icon, onClick }) => (
  <NavLink
    to={to}
    end
    onClick={onClick}
    className='text-decoration-none'
    style={({ isActive }) => ({
      display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px',
      borderRadius: 8, marginBottom: 2, fontWeight: 500, fontSize: 14,
      color: isActive ? '#2563eb' : '#6b7280',
      background: isActive ? '#eff6ff' : 'transparent', transition: 'all 0.15s ease',
    })}
    onMouseEnter={e => { if (!e.currentTarget.classList.contains('active')) { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#374151'; } }}
    onMouseLeave={e => { if (!e.currentTarget.classList.contains('active')) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#6b7280'; } }}
  >
    <i className={icon} style={{ fontSize: 14, width: 16, textAlign: 'center', flexShrink: 0 }} />
    {label}
  </NavLink>
);

const SidebarBody = ({ hideHeading = false, onNavigate }) => (
  <div>
    {!hideHeading && (
      <div style={{ marginBottom: 16, paddingBottom: 14, borderBottom: '1px solid #f3f4f6' }}>
        <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#9ca3af' }}>Email Marketing</span>
      </div>
    )}
    <nav style={{ display: 'flex', flexDirection: 'column' }}>
      {NAV_ITEMS.map(item => <EmailLink key={item.to} {...item} onClick={onNavigate} />)}
    </nav>
  </div>
);

export default function EmailLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0) }, [pathname]);   // block form: React 19 calls non-undefined returns as cleanup
  const [showMenu, setShowMenu] = useState(false);

  return (
    <div style={{ display: 'flex', minHeight: '80vh', gap: 24, marginLeft: -28 }}>
      {/* Mobile top bar */}
      <div className='d-md-none' style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 52, background: '#fff', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', zIndex: 100, padding: '0 16px', gap: 10 }}>
        <Button variant='link' style={{ color: '#374151', padding: 4 }} onClick={() => setShowMenu(true)}><List size={22} /></Button>
        <span style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>Email Marketing</span>
      </div>

      {/* Desktop sub-sidebar */}
      <div className='d-none d-md-block' style={{ width: 180, minWidth: 180, background: '#fff', borderRight: '1px solid #e5e7eb', padding: '8px 16px 8px 18px', alignSelf: 'stretch', position: 'sticky', top: 24 }}>
        <SidebarBody />
      </div>

      {/* Mobile offcanvas */}
      <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} className='d-md-none' scroll style={{ maxWidth: 260 }}>
        <Offcanvas.Header closeButton style={{ borderBottom: '1px solid #f3f4f6' }}>
          <Offcanvas.Title style={{ fontWeight: 800, fontSize: 16 }}>Email Marketing</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='pt-2'>
          <SidebarBody hideHeading onNavigate={() => setShowMenu(false)} />
        </Offcanvas.Body>
      </Offcanvas>

      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}><Outlet /></div>
    </div>
  );
}
